// extracted by mini-css-extract-plugin
module.exports = {"container":"GetStarted_container__2sLWG","buttons":"GetStarted_buttons__1uOs1","back":"GetStarted_back__36RMu","next":"GetStarted_next__2wUwu"};